const api = process.env.VUE_APP_API_URL;
export const base_game = api + "/api/v1";